const baseUrl = 'https://api.oicar.com.br/api'
// const baseUrl = 'https://api.oicar.dev.br/api'
// const baseUrl = 'http://localhost:8080/api'

export default baseUrl
